import React from 'react';
import angry from '../../assets/mascot/kork-angry.png';
import cheeky from '../../assets/mascot/kork-cheeky.png';
import chest from '../../assets/mascot/kork-chest.png';
import happy from '../../assets/mascot/kork-happy.png';
import magnet from '../../assets/mascot/kork-magnet.png';
import map from '../../assets/mascot/kork-map.png';
import pfandLeft from '../../assets/mascot/kork-pfand-left.png';
import pfandRight from '../../assets/mascot/kork-pfand-right.png';
import surprised from '../../assets/mascot/kork-surprised.png';
import tip from '../../assets/mascot/kork-tip.png';
import wow from '../../assets/mascot/kork-wow.png';
import { KORK_MOODS, KORK_MOTIONS } from '../../mascot/captainKork';

const KORK_ASSET_URLS = [
  angry,
  cheeky,
  chest,
  happy,
  magnet,
  map,
  pfandLeft,
  pfandRight,
  surprised,
  tip,
  wow,
];

if (typeof window !== 'undefined') {
  window.requestIdleCallback?.(() => {
    KORK_ASSET_URLS.forEach((src) => {
      const image = new window.Image();
      image.src = src;
    });
  }) || window.setTimeout(() => {
    KORK_ASSET_URLS.forEach((src) => {
      const image = new window.Image();
      image.src = src;
    });
  }, 1);
}

const HEAD_ASSETS = {
  [KORK_MOODS.happy]: happy,
  [KORK_MOODS.surprised]: surprised,
  [KORK_MOODS.cheeky]: cheeky,
  [KORK_MOODS.proud]: wow,
  [KORK_MOODS.hint]: tip,
  [KORK_MOODS.worried]: angry,
  [KORK_MOODS.wow]: wow,
  [KORK_MOODS.angry]: angry,
};

const POSE_ASSETS = {
  [KORK_MOODS.happy]: pfandRight,
  [KORK_MOODS.surprised]: surprised,
  [KORK_MOODS.cheeky]: cheeky,
  [KORK_MOODS.proud]: wow,
  [KORK_MOODS.hint]: tip,
  [KORK_MOODS.worried]: angry,
  [KORK_MOODS.wow]: wow,
  [KORK_MOODS.angry]: angry,
};

const NAMED_ASSETS = {
  angry,
  cheeky,
  chest,
  happy,
  head: happy,
  magnet,
  map,
  pfandLeft,
  pfandRight,
  surprised,
  tip,
  wow,
};

const SIZE_PX = {
  tiny: 54,
  small: 88,
  medium: 112,
  large: 162,
};

function normalizeMood(mood) {
  return Object.values(KORK_MOODS).includes(mood) ? mood : KORK_MOODS.happy;
}

function normalizeMotion(motion) {
  return Object.values(KORK_MOTIONS).includes(motion) ? motion : KORK_MOTIONS.bob;
}

function resolveAsset({ mood, size, variant }) {
  if (variant && NAMED_ASSETS[variant]) {
    return NAMED_ASSETS[variant];
  }

  const nextMood = normalizeMood(mood);

  if (variant === 'head' || size === 'tiny') {
    return HEAD_ASSETS[nextMood] || happy;
  }

  return POSE_ASSETS[nextMood] || pfandRight;
}

export function CaptainKork({
  mood = KORK_MOODS.happy,
  motion = KORK_MOTIONS.bob,
  size = 'medium',
  variant = 'auto',
  label = '',
  className = '',
  loading = 'eager',
}) {
  const src = resolveAsset({ mood, size, variant });
  const nextMood = normalizeMood(mood);
  const classes = [
    'pfp-kork',
    `is-${nextMood}`,
    `motion-${normalizeMotion(motion)}`,
    `size-${size}`,
    className,
  ].filter(Boolean).join(' ');
  const sizePx = SIZE_PX[size] || SIZE_PX.medium;

  return (
    <span
      className={classes}
      style={{
        display: 'inline-grid',
        placeItems: 'center',
        width: sizePx,
        height: Math.round(sizePx * 1.08),
        lineHeight: 0,
        transformOrigin: '50% 92%',
      }}
    >
      <img
        className="pfp-kork__img"
        src={src}
        alt={label || ''}
        aria-hidden={label ? undefined : 'true'}
        draggable="false"
        loading={loading}
        decoding="async"
        fetchPriority={loading === 'eager' ? 'high' : 'auto'}
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          userSelect: 'none',
          filter: 'drop-shadow(0 10px 12px rgba(0, 0, 0, 0.22))',
        }}
      />
    </span>
  );
}
